import jsQR from "jsqr";

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("ไม่สามารถอ่านไฟล์ภาพได้"));
    reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () =>
      reject(new Error("ไม่สามารถโหลดภาพสำหรับอ่าน QR ได้"));
    image.src = src;
  });
}

export default async function decodeSlipQr(file) {
  if (!file) {
    throw new Error("กรุณาเลือกไฟล์ภาพสลิป");
  }

  if (!String(file.type || "").startsWith("image/")) {
    throw new Error("รองรับเฉพาะไฟล์ภาพเท่านั้น");
  }

  const previewUrl = await readFileAsDataUrl(file);
  const image = await loadImage(previewUrl);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d", { willReadFrequently: true });

  if (!context) {
    throw new Error("เบราว์เซอร์ไม่รองรับการประมวลผลภาพ");
  }

  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;
  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
  const decoded = jsQR(imageData.data, imageData.width, imageData.height, {
    inversionAttempts: "attemptBoth",
  });

  if (!decoded?.data) {
    throw new Error("ไม่พบ QR Code ในภาพ กรุณาใช้ภาพสลิปที่คมชัด");
  }

  return {
    payload: decoded.data,
    previewUrl,
  };
}
